import { TextField, ReferenceField, useRecordContext, Labeled, RecordContextProvider } from "react-admin";
import { Grid, Box, Table, TableHead, TableRow, TableCell, TableBody, TableContainer } from "@mui/material";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import { useMediaQuery } from "@mui/material";
import { specialistRequests } from "api/specialistApi";
import { administrationRequests } from "api/administrationApi";

const MobileSpecializationsList = () => {
  const record = useRecordContext();

  if (!record?.specializationOptions?.length) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
    >
      {record.specializationOptions.map((item, index) => (
        <RecordContextProvider
          key={index}
          value={item}
        >
          <Box
            display="flex"
            flexDirection="column"
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 2,
              boxShadow: 1,
              backgroundColor: "#fff",
            }}
          >
            <Labeled label="Специалност">
              <ReferenceField
                source="specializationId"
                reference={specialistRequests.getSpecializationsSelect()}
                link={false}
              >
                <TextField source="nameBg" />
              </ReferenceField>
            </Labeled>
            <Labeled label="База за обучение">
              <ReferenceField
                source="trainingBuildingId"
                reference={specialistRequests.getTrainingBuildingsSelect()}
                link={false}
              >
                <TextField source="buildingNameBg" />
              </ReferenceField>
            </Labeled>
            <Labeled label="Тип прием">
              <ReferenceField
                source="receptionTypeId"
                reference={administrationRequests.getReceptionTypesSelect()}
                link={false}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>

            <Labeled label="Приоритет">
              <TextField source="priority" />
            </Labeled>
          </Box>
        </RecordContextProvider>
      ))}
    </Box>
  );
};

const DesktopSpecializationsTable = () => {
  const record = useRecordContext();

  if (!record?.specializationOptions?.length) return null;

  return (
    <TableContainer sx={settings.style.customDatagridStyle}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Специалност</TableCell>
            <TableCell>База за обучение</TableCell>
            <TableCell>Тип прием</TableCell>
            <TableCell>Приоритет</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {record.specializationOptions.map((item, index) => (
            <RecordContextProvider
              key={index}
              value={item}
            >
              <TableRow>
                <TableCell>
                  <ReferenceField
                    source="specializationId"
                    reference={specialistRequests.getSpecializationsSelect()}
                    link={false}
                  >
                    <TextField source="nameBg" />
                  </ReferenceField>
                </TableCell>
                <TableCell>
                  <ReferenceField
                    source="trainingBuildingId"
                    reference={specialistRequests.getTrainingBuildingsSelect()}
                    link={false}
                  >
                    <TextField source="buildingNameBg" />
                  </ReferenceField>
                </TableCell>
                <TableCell>
                  <ReferenceField
                    source="receptionTypeId"
                    reference={administrationRequests.getReceptionTypesSelect()}
                    link={false}
                  >
                    <TextField source="name" />
                  </ReferenceField>
                </TableCell>

                <TableCell>
                  <TextField source="priority" />
                </TableCell>
              </TableRow>
            </RecordContextProvider>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const SpecializationsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Grid
      container
      spacing={2}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <Grid
        item
        xs={12}
      >
        <SectionTitle
          title="Специализации"
          paddingY={0}
        />
      </Grid>

      <Grid
        item
        xs={12}
      >
        {isMobile ? <MobileSpecializationsList /> : <DesktopSpecializationsTable />}
      </Grid>
    </Grid>
  );
};

export default SpecializationsSection;
